import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

interface Breadcrumb {
  label: string;
  href: string;
}

export const useBreadcrumbs = (): Breadcrumb[] => {
  const [breadcrumbs, setBreadcrumbs] = useState<Breadcrumb[]>([]);

  const router = useRouter();

  const handleDynamicSlug = async (
    id: string,
    fullPath: string
  ): Promise<string> => {
    switch (fullPath) {
      // case '/category-insights/dashboards/[id]':
      //   return await fetchDashboardName(parseInt(id));
      case '/category-insights/reports/[folderId]':
        return '';
      default:
        return id;
    }
  };

  const getBreadcrumbLabel = async (
    value: string,
    href: string
  ): Promise<string> => {
    if (
      router &&
      router.isReady &&
      value.startsWith('[') &&
      value.endsWith(']')
    ) {
      const paramName = value.slice(1, -1);
      const paramValue = router.query[paramName] as string;
      return await handleDynamicSlug(paramValue, href);
    }

    if (href === '/oscx') {
      return 'OSCX™';
    }
    if (href === '/digital-shelf/share-of-search') {
      return 'Share of Search';
    }

    if (href === '/category-insights/reports') {
      return 'Category Reports';
    }

    return value
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const generateBreadcrumbs = async () => {
    const pathnames = router.pathname.split('/').filter((x) => x);
    const asPathnames = router.asPath.split('/').filter((x) => x);

    const breadcrumbPromises = pathnames.map(async (value, index) => {
      const href = `/${pathnames.slice(0, index + 1).join('/')}`;
      const asPath = `/${asPathnames.slice(0, index + 1).join('/')}`;
      const label = await getBreadcrumbLabel(value, href);
      return { label, href: asPath };
    });

    const resolvedBreadcrumbs = await Promise.all(breadcrumbPromises);
    // filter out labels that are empty string
    setBreadcrumbs(
      resolvedBreadcrumbs.filter((breadcrumb) => !!breadcrumb.label)
    );
  };

  useEffect(() => {
    generateBreadcrumbs();
  }, [router.pathname, router.query]);

  return breadcrumbs;
};

export const renderTitle = (
  breadcrumbs: {
    label: string;
    href: string;
  }[]
) => {
  let title = '';
  if (breadcrumbs.length === 0) {
    title = breadcrumbs[0]?.label;
  } else if (breadcrumbs[breadcrumbs.length - 1]?.label !== '') {
    title = breadcrumbs[breadcrumbs.length - 1]?.label;
  } else if (breadcrumbs[breadcrumbs.length - 1]?.label === '') {
    title = breadcrumbs[breadcrumbs.length - 2]?.label;
  }
  if (!title) {
    return '';
  }
  return ` - ${title}`;
};
